module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5bf3ab9f0225769a36ad4b100f36c36f.png";